export default __webpack_public_path__ + "media/guidelines/dont-d0d6faa3.png";